import { Config } from '../../config';
import {
    ICreateAndPopulateCartRequest,
    ICreateAndPopulateCartResponse,
    ICreateCustomerRequest,
    IMatchingCustomerResponse,
    IReservePhoneNumbersRequest,
    IReservePhoneNumbersResponse
} from './Idi.api.types';
import axios from 'axios';

const CustomerUrl = `${Config.url.IDI_URL}/api/v1/Customer`;

const ReserveNumbersUrl = `${Config.url.IDI_URL}/ReservePhoneNumber`;

const DuplicateSsnUrl = `${CustomerUrl}/CheckForDuplicateSSN`;

export const CreateCustomer = (createCustomerRequest: ICreateCustomerRequest) => {
    axios.post(`${CustomerUrl}/CreateCustomer`, createCustomerRequest).then((response) => {
        console.log('created customer', response);
    });
};

export const ReserveNumbers = (
    customerId: number,
    request: IReservePhoneNumbersRequest,
    onSuccess: (response: IReservePhoneNumbersResponse) => void,
    onFailure: () => void
) => {
    axios.post(`${ReserveNumbersUrl}/${customerId}`, request).then((response) => {
        onSuccess(response.data);
    }, onFailure);
};

export const CreateCart = (
    request: ICreateAndPopulateCartRequest,
    onSuccess: (response: ICreateAndPopulateCartResponse) => void,
    onFailure: (reason: object) => void
) => {
    axios.post(`${Config.url.PAYMENT_URL}`, request).then(
        (response) => {
            onSuccess(response.data);
        },
        (reason) => {
            onFailure(reason);
        }
    );
};

export const DuplicateCustomerCheck = (
    ssn: string,
    onSuccess: (response: IMatchingCustomerResponse[]) => void,
    onFailure: () => void
) => {
    axios.get(`${DuplicateSsnUrl}/${ssn}`).then((response) => onSuccess(response.data), onFailure);
};
